import { render, staticRenderFns } from "./aba-catalogo.vue?vue&type=template&id=339904d2&scoped=true"
import script from "./aba-catalogo.vue?vue&type=script&lang=js"
export * from "./aba-catalogo.vue?vue&type=script&lang=js"
import style0 from "./aba-catalogo.vue?vue&type=style&index=0&id=339904d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339904d2",
  null
  
)

export default component.exports